var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLu = function SvgLu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 19.5,
    x: 0.25,
    y: 0.25,
    fill: "#fff",
    stroke: "#f5f5f5",
    strokeWidth: 0.5,
    rx: 1.75
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "LU_svg__a",
    width: 28,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 19.5,
    x: 0.25,
    y: 0.25,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 1.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#LU_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f14455",
    d: "M0 6.667h28V0H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29b4ee",
    d: "M0 20h28v-6.666H0Z"
  }))));
};
export { SvgLu as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgdmlld0JveD0iMCAwIDI4IDIwIgogICBmaWxsPSJub25lIgogICB2ZXJzaW9uPSIxLjEiCiAgIGlkPSJzdmcxMyIKICAgc29kaXBvZGk6ZG9jbmFtZT0iODZjMmViMDE4YTBlZmY3YzFhMTFlMDBiMTFjZjBmNWMuc3ZnIgogICB4bWxuczppbmtzY2FwZT0iaHR0cDovL3d3dy5pbmtzY2FwZS5vcmcvbmFtZXNwYWNlcy9pbmtzY2FwZSIKICAgeG1sbnM6c29kaXBvZGk9Imh0dHA6Ly9zb2RpcG9kaS5zb3VyY2Vmb3JnZS5uZXQvRFREL3NvZGlwb2RpLTAuZHRkIgogICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxkZWZzCiAgICAgaWQ9ImRlZnMxNyIgLz4KICA8c29kaXBvZGk6bmFtZWR2aWV3CiAgICAgaWQ9Im5hbWVkdmlldzE1IgogICAgIHBhZ2Vjb2xvcj0iI2ZmZmZmZiIKICAgICBib3JkZXJjb2xvcj0iIzY2NjY2NiIKICAgICBib3JkZXJvcGFjaXR5PSIxLjAiCiAgICAgaW5rc2NhcGU6cGFnZXNoYWRvdz0iMiIKICAgICBpbmtzY2FwZTpwYWdlb3BhY2l0eT0iMC4wIgogICAgIGlua3NjYXBlOnBhZ2VjaGVja2VyYm9hcmQ9IjAiIC8+CiAgPHJlY3QKICAgICB4PSIwLjI1IgogICAgIHk9IjAuMjUiCiAgICAgd2lkdGg9IjI3LjUiCiAgICAgaGVpZ2h0PSIxOS41IgogICAgIHJ4PSIxLjc1IgogICAgIGZpbGw9IiNmZmZmZmYiCiAgICAgc3Ryb2tlPSIjZjVmNWY1IgogICAgIHN0cm9rZS13aWR0aD0iMC41IgogICAgIGlkPSJyZWN0MiIgLz4KICA8bWFzawogICAgIGlkPSJtYXNrMF8xMzkyXzM1NTQ5IgogICAgIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiCiAgICAgeD0iMCIKICAgICB5PSIwIgogICAgIHdpZHRoPSIyOCIKICAgICBoZWlnaHQ9IjIwIj4KICAgIDxyZWN0CiAgICAgICB4PSIwLjI1IgogICAgICAgeT0iMC4yNSIKICAgICAgIHdpZHRoPSIyNy41IgogICAgICAgaGVpZ2h0PSIxOS41IgogICAgICAgcng9IjEuNzUiCiAgICAgICBmaWxsPSIjZmZmZmZmIgogICAgICAgc3Ryb2tlPSIjZmZmZmZmIgogICAgICAgc3Ryb2tlLXdpZHRoPSIwLjUiCiAgICAgICBpZD0icmVjdDQiIC8+CiAgPC9tYXNrPgogIDxnCiAgICAgbWFzaz0idXJsKCNtYXNrMF8xMzkyXzM1NTQ5KSIKICAgICBpZD0iZzExIj4KICAgIDxwYXRoCiAgICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICBkPSJNIDAsNi42NjY2NyBIIDI4IFYgMCBIIDAgWiIKICAgICAgIGZpbGw9IiNmMTQ0NTUiCiAgICAgICBpZD0icGF0aDciIC8+CiAgICA8cGF0aAogICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgZD0iTSAwLDIwLjAwMDIgSCAyOCBWIDEzLjMzMzUgSCAwIFoiCiAgICAgICBmaWxsPSIjMjliNGVlIgogICAgICAgaWQ9InBhdGg5IiAvPgogIDwvZz4KPC9zdmc+Cg==";